(function() {
    angular.module('emarket.main.customfield', []);
}());

(function() {
    angular.module('emarket.main.customfield', []);
}());
